import React, { useRef, useEffect, useState } from 'react';
import columnClasses from '../columns.css';
import Select from 'react-select';
import { OptionGst } from '../../../UI/select';
import { customStylesGST } from '../../../UI/select-styles';
import DataTableInput from '../../../Input/input';
import { menuPlacement, menuPlacementR1 } from '../selectHelper';

const propsAreEqual = (prev, next) => {
    return prev.focus === next.focus
        && prev.active === next.active
        && prev.row === next.row;
}

const GST = ({ coords, row, width, transactionCodes, isCreditCard, disabled, isRuleFound, focus, active, elementFocused, isR1, handleGST }) => {
    const gstActiveInput = useRef(null);
    const gstPassiveInput = useRef(null);
    const [mouseActive, setMouseActive] = useState(false);
    const taxPurchase = transactionCodes.taxCodes.filter((item) => item.isPurchase);
    const taxSale = isCreditCard ? taxPurchase : transactionCodes.taxCodes.filter((item) => item.isSales);

    useEffect(() => {
        if (!disabled) {
            if (!active)
                setMouseActive(false);
            if (gstPassiveInput.current)
                gstPassiveInput.current.blur();
            if (gstActiveInput.current) {
                if (active)
                    gstActiveInput.current.focus();
            }
        }
    }, [active, gstActiveInput, gstPassiveInput]);

    const selectTemplateClicked = (elem) => {
        setMouseActive(true);
        elementFocused();
    }

    const onSelectGST = (gstValue) => {
        handleGST(gstValue, row);
    }

    const gstSelectKeyDown = e => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            onSelectGST(null);
        }
    }

    const gstValue = (row.Coding.length && row.GstCode && !isRuleFound(row)) ? transactionCodes.taxCodes.find(item => item.value === row.GstCode) : null;

    if ((active !== true || disabled)) {
        return <DataTableInput
            inputElementType="text"
            value={gstValue ? gstValue.value : `Select...`}
            onClick={(e) => { if (!disabled) selectTemplateClicked(e.target) }}
            onFocus={elementFocused}
            // elementRef={accountInputTemplate}
            disabled={disabled}
            loading={mouseActive}
        />
    } else {
        return <Select
            name={`${row.BankDataGUID}_gst`}
            ref={gstActiveInput}
            onChange={(value) => onSelectGST(value)}
            value={gstValue}
            placeholder={row.Coding.length > 1 ? '' : 'Select...'}
            isClearable={false}
            isDisabled={disabled}
            isOptionDisabled={(option) => option.isActive === false}
            blurInputOnSelect
            closeMenuOnSelect
            formatOptionLabel={(option) => option.value}
            onFocus={elementFocused}
            components={{ Option: OptionGst }}
            options={row.Amount < 0 ? taxPurchase : taxSale}
            styles={customStylesGST}
            maxWidth={width}
            className={columnClasses.inputElement}
            menuPortalTarget={!isR1 ? document.getElementById(`DataTable`) : ''}
            defaultMenuIsOpen={mouseActive}
            onKeyDown={gstSelectKeyDown}
            menuPlacement={isR1 ? menuPlacementR1(coords.x, window.innerHeight * 0.38, 'bottom') : menuPlacement(coords.x, window.innerHeight * 0.38, 'auto')}//0.38 is comming from max Heigth of menu(in this case customStylesAcc.menulist.maxHeight is 38vh)
        />
    }
}

export default React.memo(GST, propsAreEqual);


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/GST/gst.js